var map = {
	"./music-instructions.json": 5480,
	"./music-library-intro2024.json": 5481,
	"./music-library-launch2024.json": 5482,
	"./music-progression.json": 5483,
	"./startSourcesAdvanced.json": 5484,
	"./startSourcesSimple.json": 5485,
	"./startSourcesSimple2.json": 5486,
	"./startSourcesTracks.json": 5487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5042;